import { useEffect, useRef, useState } from "react";
import {
  Container,
  ContainerView,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { TitleWithBack } from "../../components/Layout";

import { Divider, Form } from "antd";
import {
  formatCurrency,
  getWallet,
  getWalletList,
  getWalletListSzt,
  getWalletMLM,
  roundNumber,
} from "../../services/app";
import ModalPhoneVerify from "./modal";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DetailBalance } from "./detail-balance";
import { TYPE_WALLET_DETAIL } from "../../constants";
import TransactionHistory from "./components/transaction-history";
import { ModalDeposit } from "./ModalDeposit";
import { getCoinCodeImage } from "../../utils/helper";
const defaultValueMLM = {
  possibleBalanceSZT: 0,
  frozenBalanceSZT: 0,
};
export default function WalletDetailHistory(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    currencies,
    setAlert,
    setLoading,
    user,
    isMobile,
  } = useApp();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let { tab, walletId } = {
    tab: searchParams.get("tab"),
    id: searchParams.get("id"),
    code: searchParams.get("code"),
    walletId: searchParams.get("walletId"),
    ...(useParams() || {}),
  };
  const [wallet, setWallet] = useState({});
  const [wallets, setWallets] = useState([]);
  const [form] = Form.useForm();
  const [modal, setModal] = useState(false);
  const [modalDeposit, setModalDeposit] = useState(false);
  const [detailBalanceModal, setDetailBalanceModal] = useState();
  const isOptionType = tab === TYPE_WALLET_DETAIL.OPTION;

  useEffect(() => {
    loadData().then((currencyCode) => {
      form.setFieldsValue({ from: currencyCode || "" });
    });
  }, [tab, walletId]);

  const onBack = () => {
    navigate(`/wallet/?type=${isOptionType ? "option" : tab}`);
  };

  const loadData = async () => {
    setLoading(true);
    let currentWallet = "";
    let result = {};
    const resultWalletList = await getWalletList();
    let items = [];
    if (resultWalletList.status === 200) {
      items = resultWalletList?.data?.data?.wallets?.rows || [];
    }
    setWallets(items);
    setLoading(false);
    return currentWallet;
  };

  const convertData = () => {
    return {
      wallet: {
        ...wallet,
        coin: wallet.currency_code,
        code: wallet.currency_code,
        cName: getNameByCode(wallet?.currency_code),
        coinName: T(
          `${getNameByCode(wallet?.currency_code) || ""} (${
            wallet.currency_code
          })`
        ),
        amount: wallet.dog_food,
        amountText: `${formatCurrency(wallet?.dog_food || 0, null, getCurrency())} ${
          wallet.currency_code
        }`,
        local: convertToLocalCurrency(
          wallet.dog_food,
          wallet.currency_code,
          getCurrency()
        ),
        localText: formatLocalCurrency(
          convertToLocalCurrency(
            wallet.dog_food,
            wallet.currency_code,
            getCurrency()
          ) || 0
        ),
        icon: `/assets/images/otc/crypto/${getCoinCodeImage(
          wallet?.currency_code?.toLowerCase() || "szt"
        )}.svg`,
      },
      rows: wallets.map((item, index) => {
        const data = {
          ...item,
          coin: item.currency_code,
          amount: item.dog_food,
          coinName: T(
            TYPE_WALLET_DETAIL.GAMECURRENCY
              ? "SZT"
              : `${getNameByCode(item?.currency_code)} (${item.currency_code})`
          ),
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        };
        return data;
      }),
    };
  };

  const getNameByCode = (code) => {
    return currencies.find((item) => item.code === code)?.name || "";
  };

  const value = convertData()?.wallet || {};

  const renderTitle = () => {
    return "Transaction History";
  };

  return (
    <Container>
      <ContainerView>
        <TitleWithBack title={T(renderTitle())} onClick={onBack} />
        <TransactionHistory />
      </ContainerView>

      {modal ? (
        <ModalPhoneVerify
          onClose={(value) => {
            setModal(null);
            if (value) {
              setAlert({
                type: value,
                text:
                  value === "success"
                    ? T("Successfully verified your phone number")
                    : "",
              });
            }
            if (value === "success") {
            }
          }}
          value={modal}
        />
      ) : null}

      {modalDeposit && (
        <ModalDeposit value={value} onClose={() => setModalDeposit(false)} />
      )}

      {detailBalanceModal ? (
        <DetailBalance
          type={tab}
          wallet={wallet}
          id={walletId}
          onClose={() => {
            setDetailBalanceModal(null);
          }}
        />
      ) : null}
    </Container>
  );
}
